import React from "react";
import { Link } from "react-router-dom";
import "../styles/Blog.css";

function Blog() {
  return (
    <div className="blog-page">
      {/* 🔥 Dynamic Blog Header */}
      <header className="blog-header">
        <div className="blog-overlay"></div>
        <div className="blog-header-content">
          <h1 className="blog-title">
            The Future of <span className="blog-highlight">Brain Health</span>
          </h1>
          <p className="blog-subtitle">
            AI, neuroscience, and technology transforming concussion detection.
          </p>
        </div>
      </header>

      {/* 🔥 Blog Content */}
      <div className="blog-container">
        {/* ✅ Blog Post 1 */}
        <article className="blog-post">
          <Link to="/blog1" className="blog-link">
            <div className="blog-metadata">
              <span className="blog-date">September 2024</span>
            </div>
            <h2 className="blog-post-title">AI in Concussion Detection</h2>
            <p className="blog-excerpt">
              Exploring the role of artificial intelligence in diagnosing and preventing concussions in real time.
            </p>
          </Link>
        </article>

        {/* ✅ Blog Post 2 */}
        <article className="blog-post">
          <Link to="/blog2" className="blog-link">
            <div className="blog-metadata">
              <span className="blog-date">October 2024</span>
            </div>
            <h2 className="blog-post-title">Blockchain & Medical Data</h2>
            <p className="blog-excerpt">
              How blockchain technology ensures secure, tamper-proof medical records for athletes and military personnel.
            </p>
          </Link>
        </article>

        {/* ✅ Blog Post 3 */}
        <article className="blog-post">
          <Link to="/blog3" className="blog-link">
            <div className="blog-metadata">
              <span className="blog-date">November 2024</span>
            </div>
            <h2 className="blog-post-title">Preventing CTE</h2>
            <p className="blog-excerpt">
              How AI and neuroscience are working together to reduce the risk of chronic traumatic encephalopathy.
            </p>
          </Link>
        </article>

        {/* ✅ Blog Post 4 */}
        <article className="blog-post">
          <Link to="/blog4" className="blog-link">
            <div className="blog-metadata">
              <span className="blog-date">December 2024</span>
            </div>
            <h2 className="blog-post-title">AI-Powered Sideline Evaluations</h2>
            <p className="blog-excerpt">
              A deep dive into how AI is revolutionizing sideline concussion testing.
            </p>
          </Link>
        </article>

        {/* ✅ Blog Post 5 */}
        <article className="blog-post">
          <Link to="/blog5" className="blog-link">
            <div className="blog-metadata">
              <span className="blog-date">January 2025</span>
            </div>
            <h2 className="blog-post-title">The Role of Wearable Tech in Brain Health</h2>
            <p className="blog-excerpt">
              How smart helmets and biometric tracking are providing real-time concussion risk assessments.
            </p>
          </Link>
        </article>

        {/* ✅ Blog Post 6 */}
        <article className="blog-post">
          <Link to="/blog6" className="blog-link">
            <div className="blog-metadata">
              <span className="blog-date">February 2025</span>
            </div>
            <h2 className="blog-post-title">The Future of AI in Neuroscience</h2>
            <p className="blog-excerpt">
              AI is now being used to predict neurological disorders and enhance brain-machine interfaces.
            </p>
          </Link>
        </article>
      </div>
    </div>
  );
}

export default Blog;